<template>
  <div>
    <Header />
    <ul class="list-wrapper">
      <li
      class="list-item"
      v-for="(item,index) in list" :key="item.id"
      @click="toDetail(item.id)"
      >
          <img v-lazy="item.image1Link" alt="">
        <div :class="index%2 == 0 ? 'bar-info' : 'odd-line'">
          <div  class="info-name">
            <span class="name"> {{item.name}}</span>
          </div>
          <div class="info-line"></div>
        </div>
      </li>
    </ul>
    <div class="mask" v-if="loading">
      <div class="sub">
        <img src="@/assets/img/Spinner-1s-50px.svg" alt="">
      </div>
    </div>
    <!-- 底部商家联系 -->
    <Concatc />
  </div>
</template>
<script>
import Header from '@/components/header/header';
import Concatc from '@/components/concatc/concatc';
import CONSTANT from '@/constant/constant.js';
import common from '@/common.js';
export default {
  components: {
    Header,
    Concatc
  },
  data(){
    return{
      list:[],
      loading:true,
      listLength:'',
      isOdd: this.listLength%2 == 0 ? 'info-name' : 'odd-line'
    }
  },
  created(){
    this. getImgInfo();
  },
  methods:{
    // 获取顶部图片
    getImgInfo(){
      let url = CONSTANT.CATEGORY.LIST;
      common.postNoSess(url, null,null, res => {
        let data = res.data.bussData;
         this.loading = false;
        console.log(res);
        var newData = data.map(item=>{
          return{
            image1Link:item.image1Link,
            id:item.id,
            name:item.name
          }
        })
        this.list = newData;
        this.listLength = newData.length;
      })
    },
    // 进去二级菜单页面
    toDetail(id){
      console.log(id);
      this.$router.push({path:'/appreciatechild',query:{id:id}})
    },
  },
}
</script>

<style lang="less" scope>
.list-wrapper{
  width:100%;
  .list-item{
    position: relative;
    width:100%;
    height:100%;
    margin-bottom: 138px;
    .shaow{
      width:100%;
      height:50px;
      position: absolute;
      top:-10px;
      left: 0;
      z-index:200;
    }
      img{
        width:100%;
        height:100%;
    }
    .bar-info{
      width:297px;
      float: right;
      position: relative;
      .info-name{
        margin-top:21px;
        margin-bottom:12px;
        .name{
          width:114px;
          height:27px;
          font-size:29px;
          font-family:Georgia;
          font-weight:400;
          color:rgba(89,87,87,1);
        }
      }
      .info-line{
        position: absolute;
        bottom: 0;
        right: 0;
        width:297px;
        height:2px;
        background:rgba(89,87,87,1);
      }
    }
    .odd-line{
      width:297px;
      float: left;
      position: relative;
      .info-name{
       float: right;
        margin-top:21px;
        margin-bottom:12px;
        .name{
          width:114px;
          height:27px;
          font-size:29px;
          font-family:Georgia;
          font-weight:400;
          color:rgba(89,87,87,1);
        }
      }
      .info-line{
        position: absolute;
        bottom: 0;
        right: 0;
        width:297px;
        height:2px;
        background:rgba(89,87,87,1);
      }
    }
  }
}
  .mask{
    position: fixed;
    top: 0;
    left: 0;
    width:100%;
    height:100%;
    background: rgba(0,0,0,.8);
    .sub{
      img{
        width:80px;
        height: 80px;
      }
      margin-top:50%;
      text-align: center;
      p{
        font-size:26px;
        color: #fff;
      }
    }
  }
</style>
